import { ClassName, Dialog } from "@busybusy/webapp-react-ui";
import classNames from "classnames";
import { DetailsItem } from "components";
import { useOpenable } from "hooks";
import { t } from "i18next";
import IPosition from "types/Position";
import { certificationsStatusString } from "utils/positionUtils";
import CertificationsForm from "../forms/CertificationsForm";
import { CertificationOptions } from "__generated__/graphql";

export interface ICertificationsDetailProps {
  editable: boolean;
  position: IPosition;
  onUpdate: () => Promise<any>;
  className?: ClassName;
}

const CertificationsDetail = (props: ICertificationsDetailProps) => {
  const { position, onUpdate, editable, className } = props;

  const editDialog = useOpenable();

  function onSubmit() {
    editDialog.close();
    onUpdate();
  }

  const classes = classNames('certifications-detail', className);

  return (
    <>
      <DetailsItem
        title={t('Certifications')}
        onClick={editDialog.open}
        value={certificationsStatusString(position)}
        hint={t(`View, create, edit, and delete certifications. Optionally allow a supervisor to view certifications for his entire crew, but only be able to manage their own.`)}
        className={classes}
        disabled={!editable}
      />
      <Dialog
        position={'center'}
        isOpen={editDialog.isOpen}
        onClose={editDialog.close}
      >
        <CertificationsForm
          className="mt-4 p-8"
          onSubmit={onSubmit}
          positionId={position.id}
          currentSetting={position.certifications ?? CertificationOptions.ManageSelf}
        />
      </Dialog>
    </>
  )
}

export default CertificationsDetail;